import { Grid2, Typography } from "@mui/material";
import StatusBox from "../../../components/StatusBox";
import { useTranslate } from "../../../hooks/useTranslate";
import useStatuses from "../../../context/status/useStatuses";
import LockedPage from "../../../components/LockedPage";
import VerificationStatusChip from "../../../components/VerificationStatusChip";
import CalendlyWidget from "./components/CalendlyWidget";
import { KEY_PROGRESS } from "../../../utils/getVerificationStatusKey";

const ConsultationCall = () => {
    const { t } = useTranslate();
    const { isLockedStatus: { consultationCall: isLocked }, statuses } = useStatuses();

    return (
        <div className="page-content">
            <Grid2 container spacing={2} className="mb-12">
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Typography variant="h1">
                        {t("consultationCall.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4" component="div">
                        {t("consultationCall.description")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                    <StatusBox
                        title={t("consultationCall.consultationCallStatus")}
                        isSuccess={statuses.consultationCall.isSuccess}
                        isWarning={statuses.consultationCall.isWarning}
                        isInfo={statuses.consultationCall.isInfo}
                    >
                        <Typography variant="body2">
                            {statuses.consultationCall.key === KEY_PROGRESS ? (
                                t("consultationCall.scheduledCallText")
                            ) : t("consultationCall.consultationCallStatusDescription")}
                        </Typography>
                        <VerificationStatusChip status={statuses.consultationCall} />
                    </StatusBox>
                </Grid2>
            </Grid2>
            {!statuses.consultationCall.isSuccess && (
                <LockedPage isLocked={isLocked}>
                    <CalendlyWidget />
                </LockedPage>
            )}
        </div>
    );
};

export default ConsultationCall;
